import { CancelTransactionRequestDto, CancelTransactionResponseDto } from '@sparling/financial-common'
import axios, { AxiosRequestConfig } from 'axios'

export const cancelTransaction = async (
  { token, transactionId }: CancelTransactionRequestDto & { token: string; transactionId: string },
  options: AxiosRequestConfig = {},
): Promise<CancelTransactionResponseDto> => {
  const response = await axios.get<CancelTransactionResponseDto>(
    `${process.env.REACT_APP_REST_API_URL}/transactions/${transactionId}/cancel`,
    {
      ...options,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
        ...options.headers,
      },
    },
  )
  return response.data
}
